import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import * as runReducer from "containers/Run/reducer";
import * as setupReducer from "containers/Setup/reducer";

import ModelLoadingIndicator from "components/Results/ModelLoadingIndicator";

class ModelLoadingIndicatorContainer extends React.PureComponent {
  render() {
    return <ModelLoadingIndicator {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({});

const mapStateToProps = (state, ownProps) => {
  return {
    notebookProgress: runReducer.getNotebookProgress(state, ownProps.id),
    isQuickRun: setupReducer.getIsQuickRun(state, ownProps.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(ModelLoadingIndicatorContainer);
